import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouterDebugService {
	constructor(private router: Router) {}

	init() {
		this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e: NavigationStart) => {
			console.log('[NAV START]', e.url, 'search:', window.location.search, 'trigger:', e.navigationTrigger);
		});

		this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
			console.log('[NAV END]', e.urlAfterRedirects, 'search:', window.location.search);
		});
	}
}
